import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import Error from "./Error/Error";
import Login from "./Login/Login";
import Home from "./Home/Home";
import Help from "./Help/Help";
import Welcome from "./Welcome/Welcome";
import CategoryMenu from "./CategoryMenu/CategoryMenu";
import SubCategoryMenu from "./CategoryMenu/SubCategoryMenu";
import Products from "./Products/Products";
import ProductDetails from "./Products/ProductDetails";
import Cart from "./Cart/Cart";
import Checkout from "./Cart/Checkout";
import PageTransition from "./PageTransition/PageTransition";
import { useEffect, useState } from "react";

const AppRoutes = () => {

  const [isUserActive, setIsUserActive] = useState(true);
  //const navigate = useNavigate();


  useEffect(() => {
    const handleUserActivity = () => {
      setIsUserActive(true);
    };

    const handleInactiveRedirect = () => {
      setIsUserActive(false);
    };
    
    // Attach event listeners
    window.addEventListener('mousemove', handleUserActivity);
    window.addEventListener('keydown', handleUserActivity);
    window.addEventListener('scroll', handleUserActivity);

    const inactiveTimeout = setTimeout(() => {
      if (!isUserActive) {
        // Redirect to /home if the user is inactive
        window.location.href = '/';
      }
    }, 500);

    // Clear the timeout and remove event listeners on component unmount
    return () => {
      clearTimeout(inactiveTimeout);
      window.removeEventListener('mousemove', handleUserActivity);
      window.removeEventListener('keydown', handleUserActivity);
      window.removeEventListener('scroll', handleUserActivity);
    };
  }, [isUserActive]);

  return (
    <div className="disney-cafe">
      <Router>
        <PageTransition>
        <Routes>
        <Route path="/" element={<Error />} />
        <Route
        path="/:siteId/*"
        element={
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="Login" element={<Login />} />
            <Route path="welcome" element={<Welcome />} />
            <Route path="category-menu" element={<CategoryMenu />} />
            <Route path="sub-category-menu/:id" element={<SubCategoryMenu />} />
            <Route path="product/:id" element={<Products />} />
            <Route path="products/details/:id" element={<ProductDetails />} />
            <Route path="cart" element={<Cart />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="help" element={<Help />} />
          </Routes>
        }
      />
        </Routes>
        </PageTransition>

      </Router>
      </div>
  );
};

export default AppRoutes;
